import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CTA = () => {
  const { t } = useTranslation();

  return (
    <section className="py-section-lg bg-foreground text-background">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          {/* Japanese Character */}
          <span className="text-6xl font-serif text-background/10 mb-6 block">始</span>

          <p className="text-label text-background/60 mb-4">{t('cta.begin')}</p>
          
          <h2 className="text-display-lg font-serif text-background mb-6">
            {t('cta.headline')}
          </h2>

          <p className="text-body text-background/70 text-lg max-w-2xl mx-auto mb-10">
            {t('cta.subtitle')}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="outline" 
              size="xl"
              className="border-background/30 text-background hover:bg-background hover:text-foreground"
              asChild
            >
              <Link to="/contact">
                {t('cta.scheduleCall')}
              </Link>
            </Button>
            <Button 
              variant="ghost" 
              size="xl"
              className="text-background/70 hover:text-background hover:bg-background/10"
              asChild
            >
              <Link to="/packages#design-packages" state={{ fromHome: true }}>{t('cta.viewServices')}</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
